import React, { Component } from 'react';
import "./footer.css";
class Footer extends Component {
    render() {
        return (
            <div className="footer">
                <div className="footer-content">
                    <div className="footer-content-col">
                        <img className="logo" src={this.props.content.imgs.img} alt={this.props.content.imgs.alt}/>
                        <p className="raleway fw-regular">{this.props.content.description}</p>
                    </div>
                    <div className="footer-content-col">
                        <div className="footer-content-col-contact">
                            <div className="footer-content-col-contact-img">
                                <img src={this.props.content.imgs.tel}/>
                            </div>
                            <div className="footer-content-col-contact-info">
                                <h2 className="raleway fw-bold">Teléfono</h2>
                                <p className="raleway fw-regular">{this.props.content.tel}</p>
                            </div>
                        </div>
                        <div className="footer-content-col-contact">
                            <div className="footer-content-col-contact-img">
                                <img src={this.props.content.imgs.mail}/>
                            </div>
                            <div className="footer-content-col-contact-info">
                                <h2 className="raleway fw-bold">Mail</h2>
                                <p className="raleway fw-regular">{this.props.content.mail}</p>
                            </div>
                        </div>
                        <div className="footer-content-col-contact">
                            <div className="footer-content-col-contact-img">
                                <img src={this.props.content.imgs.dir}/>    
                            </div>
                            <div className="footer-content-col-contact-info">
                                <h2 className="raleway fw-bold">Dirección</h2>
                                <p className="raleway fw-regular">{this.props.content.address}</p>
                            </div>
                        </div>
                    </div>
                    <div className="footer-content-col">
                    {
                               /*
                        <div className="footer-content-col-title raleway fw-bold">SUSCRÍBETE</div>
                        <div className="subscribe-form">
                          
                               <div
                                dangerouslySetInnerHTML={{
                                __html:
                                    "<!-- Begin MailChimp Signup Form --><link href='//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css' rel='stylesheet' type='text/css'><style type='text/css'>#mc_embed_signup{background:#fff; clear:left; font:14px Helvetica,Arial,sans-serif; width:100%;}</style><div id='mc_embed_signup'><form action='https://adivor.us12.list-manage.com/subscribe/post?u=7a6567c19d6396146926ba299&amp;id=189b1be89f' method='post' id='mc-embedded-subscribe-form' name='mc-embedded-subscribe-form' class='validate' target='_blank' novalidate><div id='mc_embed_signup_scroll'><input type='email' value='' name='EMAIL' class='email' id='mce-EMAIL' placeholder='email address' required><div style='position: absolute; left: -5000px;' aria-hidden='true'><input type='text' name='b_7a6567c19d6396146926ba299_189b1be89f' tabindex='-1' value=''></div><div class='clear'><input type='submit' value='Suscribirme' name='subscribe' id='mc-embedded-subscribe' class='button'></div></div></form></div>"
                                }}
                                />
                            
                        </div>
                           */
                        }
                    </div>
                </div>
                <div className="footer-white-line" />
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/sections/Footer.js